import { z } from 'zod';
import _ from 'lodash';
// import { errorToLoggingPayload } from 'src/services/loggingService';
function validateLevel(schema, input, throwOnInvalid) {
    let level;
    try {
        level = schema.parse(input);
        return level;
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            // eslint-disable-next-line no-console
            console.debug(error.message);
            // console.error(errorToLoggingPayload(error.message)) // eslint-disable-line no-console
            if (throwOnInvalid) {
                throw error;
            }
            return level;
        }
        else {
            throw error;
        }
    }
}
export function validateAtLevel(schema, input, options = {}) {
    const { childLevel = '', throwOnInvalid = false } = options;
    // The following schema/types provide an "allowable" level type (confdefn, tab, section, view) that
    // omit the "children" of that level that may be misconfigured causing the whole level to be invalid.
    // So omit the "children" at that level so the level can pass validation independent of its "children".
    // Need to convert to slightly different zod type because 'omit' doesn't exist on union types (think view level)
    const AllowableSchema = _.isEmpty(childLevel) ? schema : schema.omit({ [childLevel]: true });
    return validateLevel(AllowableSchema, input, throwOnInvalid);
}
export function filterInvalidItem(item) {
    return !_.isNil(item);
}
export function formatAndLogLocal(errorMessage, errors) {
    /* eslint-disable no-console */
    console.groupCollapsed(`%c${errorMessage}`, 'font-size: 14px');
    console.log(`%c${'*** Basic details below. For more detailed errors enable debug/verbose messages in browser console ***'}`, 'padding: 8px 0; color: #4298db');
    errors.forEach((error) => console.log(`%c${error}`, 'padding: 8px 0'));
    console.groupEnd();
}
